/**
 * Conversión de las fechas de los filtros (`<input type="date">`, formato `yyyy-MM-dd`) al
 * instante ISO que esperan los endpoints de métricas.
 *
 * Por qué existe (INC_CRM_019 (7) inc51): los parámetros `from`/`to` del backend son
 * `OffsetDateTime`, y su converter tolera `yyyy-MM-dd` resolviéndolo al **inicio** de ese día en
 * UTC. Mandar `to = "2026-08-13"` significaba entonces "hasta las 00:00 del 13", así que TODA
 * respuesta CSAT de ese mismo día quedaba fuera del rango: la encuesta se guardaba correctamente
 * pero el panel decía "Aún no hay respuestas CSAT en el periodo seleccionado".
 *
 * El día se interpreta en la ZONA DEL NAVEGADOR (que es la que el usuario tenía delante al
 * elegirlo) y se envía como instante absoluto, para que el filtro cubra exactamente el día
 * natural que se ve en pantalla.
 */

/** `yyyy-MM-dd` → instante ISO del primer milisegundo de ese día local. */
export function inicioDelDiaIso(fecha: string): string {
  return limiteDelDia(fecha, false);
}

/** `yyyy-MM-dd` → instante ISO del último milisegundo de ese día local. */
export function finDelDiaIso(fecha: string): string {
  return limiteDelDia(fecha, true);
}

function limiteDelDia(fecha: string, esFin: boolean): string {
  const partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec((fecha ?? '').trim());
  if (!partes) {
    // Ya venía con hora (o es basura): se reenvía tal cual y que decida el backend.
    return fecha;
  }
  const [, anio, mes, dia] = partes;
  const local = esFin
    ? new Date(Number(anio), Number(mes) - 1, Number(dia), 23, 59, 59, 999)
    : new Date(Number(anio), Number(mes) - 1, Number(dia), 0, 0, 0, 0);
  return local.toISOString();
}
